import React, { useContext } from 'react';
import FacingTrouble from '../../components/FacingTrouble';
import InputField from '../../components/InputField';
import '../../../styles/getIrctcPassword.css';
import '../../../styles/facingTrouble.css';
import { checkValidation, validations } from '../../../utils/FormValidators';
import axios from 'axios';
import {
  FACING_TROUBLE_PAGE_TITLE,
  getFacingTroubleList,
  IRCTC_FORGOT_PASSWORD_COMPONENTS,
  IRCTC_PASSWORD_RADIO,
  RADIO_KEYS_LABELS_IRCTC_PASSWORD,
  SERVER_URL
} from '../../../utils/RailsSEOConstants';
import RadioButtonGroup from '../../components/RadioButtonGroup';
import { IrctcForgotPasswordContext } from '../IrctcForgotPasswordPage';
import * as irctcForgotPasswordActions from './../../../actions/irctcForgotPasswordActions';
import { crawlerDuplicateAvoidStyle } from '../../../utils/commonUtils';
import PropTypes from 'prop-types';

const GetIrctcPassword = (props) => {
  const { customClass } = props;
  const context = useContext(IrctcForgotPasswordContext);
  const {
    forgotPasswordState: {
      modeOfPasswordSent,
      userName,
      mobileNumber,
      userEmail,
      showErrorInputForm,
      submitFailedErrorMessageEmail,
      submitFailedErrorMessageMobileNumber
    },
    forgotPasswordDispatch
  } = context;

  const updateShowErrorInputForm = (latestShowError) => {
    forgotPasswordDispatch({
      type: irctcForgotPasswordActions.ACTION_SET_SHOW_ERROR_INPUT_FORM_FORGOT_PSWD,
      data: latestShowError
    });
  };
  const updateComponentToShow = (latestComponent) => {
    forgotPasswordDispatch({
      type: irctcForgotPasswordActions.ACTION_SET_COMPONENT_TO_SHOW_FORGOT_PSWD,
      data: latestComponent
    });
  };
  const updateSubmitFailedErrorMessageEmail = (latestMessage) => {
    forgotPasswordDispatch({
      type: irctcForgotPasswordActions.ACTION_SET_SUBMIT_FAILED_ERR_MSG_EMAIL,
      data: latestMessage
    });
  };

  const updateSubmitFailedErrorMessageMobile = (latestMessage) => {
    forgotPasswordDispatch({
      type: irctcForgotPasswordActions.ACTION_SET_SUBMIT_FAILED_ERR_MSG_MOBILE,
      data: latestMessage
    });
  };

  const updateModeOfPasswordSent = (event) => {
    const latestModeOfPasswordSent = event.target.id;
    forgotPasswordDispatch({
      type: irctcForgotPasswordActions.ACTION_SET_MODE_OF_PASSWORD_FORGOT_PSWD,
      data: latestModeOfPasswordSent
    });
  };

  const updateUserName = (latestUserName) => {
    if (submitFailedErrorMessageMobileNumber) {
      updateSubmitFailedErrorMessageMobile('');
    }
    if (submitFailedErrorMessageEmail) {
      updateSubmitFailedErrorMessageEmail('');
    }
    forgotPasswordDispatch({
      type: irctcForgotPasswordActions.ACTION_SET_USERNAME_FORGOT_PSWD,
      data: latestUserName
    });
  };

  const updateMobileNumber = (latestMobileNumber) => {
    if (submitFailedErrorMessageMobileNumber) {
      updateSubmitFailedErrorMessageMobile('');
    }
    forgotPasswordDispatch({
      type: irctcForgotPasswordActions.ACTION_SET_MOBILE_NUMBER_FORGOT_PSWD,
      data: latestMobileNumber
    });
  };
  const updateUserEmail = (latestUserEmail) => {
    if (submitFailedErrorMessageEmail) {
      updateSubmitFailedErrorMessageEmail('');
    }
    forgotPasswordDispatch({
      type: irctcForgotPasswordActions.ACTION_SET_USER_EMAIL_FORGOT_PSWD,
      data: latestUserEmail
    });
  };

  const isErrorPresentInFields = () => {
    const emailToValidate = [userEmail, validations.email];
    const mobileNumberToValidate = [mobileNumber, validations.mobileNumber];
    const fieldsWithValidations = [[userName, validations.userName]];
    if (modeOfPasswordSent === IRCTC_PASSWORD_RADIO.MOBILE.key) {
      fieldsWithValidations.push(mobileNumberToValidate);
    }
    if (modeOfPasswordSent === IRCTC_PASSWORD_RADIO.EMAIL.key) {
      fieldsWithValidations.push(emailToValidate);
    }

    return fieldsWithValidations.some((element) => {
      const [value, valueValidation] = element;
      if (!checkValidation(value, valueValidation)) {
        return true;
      } else {
        return false;
      }
    });
  };

  const forgotIrctcPasswordApiCall = async () => {
    try {
      // make API request
      const res = await axios.get(`${SERVER_URL}/user/irctc/details/P`, {
        params: {
          userLoginId: userName || '',
          email: modeOfPasswordSent === IRCTC_PASSWORD_RADIO.EMAIL.key ? userEmail : '',
          mobile: modeOfPasswordSent === IRCTC_PASSWORD_RADIO.MOBILE.key ? mobileNumber : '',
          otpType: IRCTC_PASSWORD_RADIO[modeOfPasswordSent].otpType,
          dob: ''
        }
      });

      // check API response
      if (res.data.error) {
        if (modeOfPasswordSent === IRCTC_PASSWORD_RADIO.MOBILE.key) {
          updateSubmitFailedErrorMessageMobile('This mobile number and username are not linked.');
        }
        if (modeOfPasswordSent === IRCTC_PASSWORD_RADIO.EMAIL.key) {
          updateSubmitFailedErrorMessageEmail('This email address and username are not linked.');
        }
      } else {
        updateComponentToShow(IRCTC_FORGOT_PASSWORD_COMPONENTS.successPage);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };

  const handleIrctcPasswordFormSubmit = async () => {
    if (isErrorPresentInFields()) {
      updateShowErrorInputForm(true);
    } else {
      await forgotIrctcPasswordApiCall();
    }
  };
  return (
    <div
      className={`${customClass} getIrctcPwd ${modeOfPasswordSent !== IRCTC_PASSWORD_RADIO.MOBILE.key ? 'noBdr' : ''}`}
    >
      <div className="getIrctcPwd__cntnt">
        <h4>Enter IRCTC Username</h4>
        <InputField
          type="text"
          placeholder="IRCTC Username"
          value={userName}
          updateParentValue={updateUserName}
          errorMsg="Enter a valid username"
          error={showErrorInputForm && !checkValidation(userName, validations.userName)}
          customClass="appendBottom30"
        />
        <h4>Enter IRCTC Registered</h4>
        <RadioButtonGroup
          radioButtonCustomClass={'radioOuterRails boxSizingContentBox'}
          value={modeOfPasswordSent}
          onRadioOptionClicked={updateModeOfPasswordSent}
          optionsObject={IRCTC_PASSWORD_RADIO}
          optionsKeysLabels={RADIO_KEYS_LABELS_IRCTC_PASSWORD}
          optionPurpose={'sendThrough'}
          radioGroupCustomStyle={'registerOption'}
        />
        {modeOfPasswordSent === IRCTC_PASSWORD_RADIO.MOBILE.key && (
          <InputField
            value={mobileNumber}
            updateParentValue={updateMobileNumber}
            maxLength={10}
            error={
              !!submitFailedErrorMessageMobileNumber ||
              (showErrorInputForm && !checkValidation(mobileNumber, validations.mobileNumber))
            }
            errorMsg={submitFailedErrorMessageMobileNumber || 'Enter a valid mobile number'}
            placeholder="Mobile number"
            customClass="appendBottom40"
          />
        )}
        {modeOfPasswordSent === IRCTC_PASSWORD_RADIO.EMAIL.key && (
          <InputField
            value={userEmail}
            updateParentValue={updateUserEmail}
            error={
              !!submitFailedErrorMessageEmail || (showErrorInputForm && !checkValidation(userEmail, validations.email))
            }
            errorMsg={submitFailedErrorMessageEmail || 'Enter a valid email address'}
            placeholder="Email id"
            customClass="appendBottom40"
          />
        )}
        <button
          style={crawlerDuplicateAvoidStyle}
          className={`blueButtonRails mobileShow fullWidth appendBottom10`}
          onClick={handleIrctcPasswordFormSubmit}
        >
          Get Password
        </button>
        <button className={`blueButtonRails desktopShow appendBottom10`} onClick={handleIrctcPasswordFormSubmit}>
          Get Password
        </button>

        <p className={'desktopShow appendBottom25'}>
          You will receive an {modeOfPasswordSent === IRCTC_PASSWORD_RADIO.MOBILE.key ? 'SMS' : 'Email'} from IRCTC with
          your new Password.
        </p>
        <p style={crawlerDuplicateAvoidStyle} className={'mobileShow'}>
          You will receive an {modeOfPasswordSent === IRCTC_PASSWORD_RADIO.MOBILE.key ? 'SMS' : 'Email'} from IRCTC with
          your new Password.
        </p>
        <p className="infoTag">
          • Maximum of 5 attempts to generate Passwords are allowed daily by IRCTC
          <br />• IRCTC username is case-sensitive
        </p>
      </div>
      <FacingTrouble facingTroubleList={getFacingTroubleList(FACING_TROUBLE_PAGE_TITLE.FORGOT_IRCTC_PASSWORD_TITLE)} />
    </div>
  );
};

GetIrctcPassword.propTypes = {
  customClass: PropTypes.string
};

export default GetIrctcPassword;
